module.exports = __webpack_public_path__ + "media/images/illustrations/online_quote-d849f6485f3ab8f87276e09317f73690.svg";